/**
 * Cart Cross-sell
 * Swiper carousel + ATC for cross-sell products in the cart drawer.
 */

(function () {
  'use strict';

  const SELECTORS = {
    wrapper: '.cart-xsell',
    swiper:  '.js-xsell-swiper',
    prev:    '.js-xsell-prev',
    next:    '.js-xsell-next',
    addBtn:  '.js-xsell-add',
  };

  let isAdding = false;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest(SELECTORS.addBtn);
    if (!btn || isAdding) return;

    const variantId = Number(btn.dataset.variantId);
    if (!variantId) return;

    isAdding = true;
    btn.classList.add('cart-xsell__card-add--loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('xsell:added'));
      })
      .catch(function (err) {
        console.error('[cart-xsell] ATC error:', err);
      })
      .finally(function () {
        btn.classList.remove('cart-xsell__card-add--loading');
        isAdding = false;
      });
  });
})();
